import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  demoContacts: [],
  demoContact: {},
  pages: 0,
};

const demoContactsSlice = createSlice({
  name: "demoContacts",
  initialState,
  reducers: {
    setDemoContacts(state, action) {
      state.demoContacts = action.payload;
    },
    setDemoContact(state, action) {
      state.demoContact = action.payload;
    },
    setPages(state, action) {
      state.pages = action.payload;
    },
    addDemoContact(state, action) {
      state.demoContacts.push(action.payload);
    },
  },
});

export function getDemoContacts({ page, pageSize }) {
  return async (dispatch) => {
    try {
      const accessToken = window.localStorage.getItem("accessToken");
      if (!accessToken) return Promise.reject("No access token");
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/demo-contact`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            page: page,
            pageSize: pageSize,
          },
        }
      );
      dispatch(
        demoContactsSlice.actions.setDemoContacts(response.data.data.data)
      );
      dispatch(demoContactsSlice.actions.setPages(response.data.data.pages));
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(demoContactsSlice.actions.setDemoContacts([]));
      dispatch(demoContactsSlice.actions.setPages(0));
      return Promise.reject(error.message);
    }
  };
}

export async function storeDemoContact({ data }) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/demo-contact`,
      data,
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_POS2CLOUD_BACKEND_BASIC_HEADER}`,
        },
      }
    );
    return Promise.resolve(response.data.message);
  } catch (error) {
    return Promise.reject(error.message);
  }
}

export function retrieveDemoContactByToken({ token }) {
  return async (dispatch) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/demo-contact/by-token`,
        {
          headers: {
            Authorization: `Basic ${process.env.REACT_APP_POS2CLOUD_BACKEND_BASIC_HEADER}`,
          },
          params: {
            token: token,
          },
        }
      );
      dispatch(demoContactsSlice.actions.setDemoContact(response.data.data));
      return Promise.resolve(response.data.message);
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
}

export default demoContactsSlice.reducer;
